import { render } from "./FullPageOrange.vue?vue&type=template&id=18875b29"
import script from "./FullPageOrange.vue?vue&type=script&lang=js"
export * from "./FullPageOrange.vue?vue&type=script&lang=js"

import exportComponent from "/Users/xianbinlin/workplace/work/projects/notionWeb/app-notion2web/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])